import React from 'react';
import styled from 'styled-components/macro';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

const ContentContainer = styled.div`
  > div {
    padding-left: ${props => props.theme.padding.contentXPercent}%;
    padding-right: ${props => props.theme.padding.contentXPercent}%;
  }

  > div:first-child {
    padding-top: ${props => props.theme.header.mobile.iconHeight + props.theme.header.mobile.paddingY + 24}px;
    @media (min-width: 768px) {
      padding-top: ${props => props.theme.header.desktop.iconHeight}px;
    }
  }
`;

const StandardLayout = ({ children }) => {
  return (
    <div>
      <Header />
      <ContentContainer>{children}</ContentContainer>
      <Footer />
    </div>
  );
};

export default StandardLayout;
